// extracted by mini-css-extract-plugin
module.exports = {"select":"BuildingSelect_select__3qKuo"};